var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeempty = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3a.5.5 0 0 1 .448.277l2.664 5.361 5.96.865a.5.5 0 0 1 .276.854l-4.31 4.17 1.017 5.888a.5.5 0 0 1-.724.528L12 18.16l-5.33 2.784a.5.5 0 0 1-.725-.528l1.017-5.889-4.31-4.169a.5.5 0 0 1 .276-.854l5.96-.865 2.664-5.36A.5.5 0 0 1 12 3Zm0 1.623L9.667 9.318a.5.5 0 0 1-.376.272l-5.211.756 3.768 3.645a.5.5 0 0 1 .145.445l-.89 5.153 4.665-2.437a.5.5 0 0 1 .463 0l4.666 2.437-.89-5.153a.5.5 0 0 1 .145-.445l3.768-3.645-5.21-.756a.5.5 0 0 1-.377-.272L12 4.623Z",
  fill: "currentColor"
})));
export { SvgTypeempty as ReactComponent };
export default __webpack_public_path__ + "77d103559f45626c0a6b29896ea4e543.svg";